import { publish } from 'pubsub-js';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetDownloadManager } from '../../../../../viewer/elements/asset-download-manager';
import { Geometry } from '../../../../../viewer/elements/geometry';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { DownloadIcon } from '../icons/download-icon';

type Props = {
  asset: Geometry;
  title?: string;
};

const ExportGeometryIcon = (props: Props) => {
  const { t } = useTranslation();

  return (
    <DownloadIcon
      key="downloadIcon"
      title={props.title}
      onClick={() => {
        try {
          // Load asset if necessary.
          if (props.asset.isReadyToLoad()) {
            props.asset.loadGeometry();
          }

          new AssetDownloadManager().downloadGeometryAsset(props.asset);
        } catch (err) {
          publish(SubscriptionTopic.ToastrMessage, {
            type: 'error',
            message: t('common.assetHeaderIcons.exportGeometry.error', { ns: 'skyviewAssetMenu' }),
          });
        }

        return Promise.resolve();
      }}
    />
  );
};

export { ExportGeometryIcon };
